/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgTextFormatBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.50364 3.63635H17.5M2.5 14.9806H8.1508M2.50364 11.2039H5.76372M2.50364 7.42014H5.76372M8.07409 8.91072V8.33742C8.07409 7.70417 8.56062 7.19082 9.16079 7.19082H12.4209M16.7676 8.91072V8.33742C16.7676 7.70417 16.2811 7.19082 15.6809 7.19082H12.4209M10.7908 16.3636H12.4209M14.0509 16.3636H12.4209M12.4209 7.19082V11.7772V16.3636"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgTextFormat = wrapIcon(SvgTextFormatBase);
export default SvgTextFormat;
